module.exports = __webpack_public_path__ + "img/alimas-logo-min.d47458ef.png";